
    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
      <ng-template #templateHolder></ng-template>
    </div>
  